import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ContractorAPIData } from '../../../core/interface/export-reports';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../core/service/common.service';
import { Router } from '@angular/router';
import { ReportsService } from '../../../core/service/reports.service';
import { trackReports } from '../../../core/constants/constants';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-variance-report',
  templateUrl: './variance-report.component.html',
  styleUrl: './variance-report.component.less',
  encapsulation: ViewEncapsulation.None,
})
export class VarianceReportComponent implements OnInit, OnDestroy {
  contractor: string = '';
  date: string = '';
  contractorDate: string = '';
  isRunVariance: boolean = false;
  trackReports = trackReports;
  getContractor!: Subscription;
  isDataAvailable: boolean = false;

  constructor(
    private readonly reportsService: ReportsService,
    private readonly datePipe: DatePipe,
    private readonly commonService: CommonService,
    private readonly route: Router
  ) {}

  ngOnInit(): void {
    this.loadContractor();
    this.commonService.setNavigationDisabled(true);
  }

  loadContractor(): void {
    this.getContractor = this.reportsService.getContractor().subscribe({
      next: (contractorData: ContractorAPIData | null) => {
        if (contractorData) {
          this.contractor = contractorData.name;
          this.date = contractorData.date;
          const transformedDate = this.datePipe.transform(
            this.date,
            'dd-MMM-yy'
          );
          this.contractorDate = transformedDate ?? '';
        } else {
          this.isRunVariance = true;
        }
      },
      error: (error) => {
        console.log('Error in loadContractor method. Error:', error);
        this.isRunVariance = true;
      },
      complete: () => {
        this.isDataAvailable = true;
      },
    });
  }

  runVarianceReports() {
    this.route.navigateByUrl('/track-reports', {
      state: {
        data: { contractor: this.contractor, date: this.date },
      },
    });
  }

  ngOnDestroy(): void {
    if (this.getContractor) {
      this.getContractor.unsubscribe();
    }
    this.commonService.setNavigationDisabled(false);
  }
}
